import type { ReactNode } from 'react';

/**
 * A label/value row inside a card — the definition-list pattern the profile,
 * settings and pay-run summary panels are built from.
 */
export function FieldRow({
  label,
  children,
}: {
  label: ReactNode;
  children: ReactNode;
}): React.JSX.Element {
  return (
    <div className="wp-fieldrow">
      <span className="wp-fieldlabel">{label}</span>
      <span className="wp-fieldval">{children}</span>
    </div>
  );
}

/**
 * A field row whose value is a monetary amount or other tabular figure.
 *
 * `wp-fieldrow--num` lets the label column give way when the figure needs
 * the room: a formatted amount ("LKR 1,242,096.77") is one unbreakable token,
 * and in a narrow card (the 300px pay-run summary) the fixed 160px label left
 * it ~92px, so it spilled past the card edge.
 */
export function NumericFieldRow({
  label,
  children,
}: {
  label: ReactNode;
  children: ReactNode;
}): React.JSX.Element {
  return (
    <div className="wp-fieldrow wp-fieldrow--num">
      <span className="wp-fieldlabel">{label}</span>
      <span className="wp-fieldval num">{children}</span>
    </div>
  );
}
